import { render, staticRenderFns } from "./ServiceCalendar.vue?vue&type=template&id=0ef02993&scoped=true"
import script from "./ServiceCalendar.vue?vue&type=script&lang=js"
export * from "./ServiceCalendar.vue?vue&type=script&lang=js"
import style0 from "./ServiceCalendar.vue?vue&type=style&index=0&id=0ef02993&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef02993",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jissjohnson/code/Zenrion/CareKraft/zenrion-erp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef02993')) {
      api.createRecord('0ef02993', component.options)
    } else {
      api.reload('0ef02993', component.options)
    }
    module.hot.accept("./ServiceCalendar.vue?vue&type=template&id=0ef02993&scoped=true", function () {
      api.rerender('0ef02993', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ServiceCalendar.vue"
export default component.exports